document.querySelectorAll('.header__nav-item--has-dropdown, .header__nav-item--mega, .header__nav-item--mega-menu').forEach((item) => {
  const trigger = item.querySelector(':scope > .header__nav-link, :scope > .header__mega-trigger');
  if (!trigger) return;

  const setExpanded = (expanded) => {
    trigger.setAttribute('aria-expanded', expanded);
  };

  item.addEventListener('mouseenter', () => {
    item.classList.remove('is-dismissed');
    setExpanded(true);
  });
  item.addEventListener('mouseleave', () => {
    item.classList.remove('is-dismissed');
    setExpanded(false);
  });
  item.addEventListener('focusin', () => {
    if (!item.classList.contains('is-dismissed')) setExpanded(true);
  });
  item.addEventListener('focusout', (event) => {
    if (!item.contains(event.relatedTarget)) {
      item.classList.remove('is-dismissed');
      setExpanded(false);
    }
  });

  // Header mega menu: Escape hides the full-width panel (it opens on hover /
  // focus, so it must be dismissible) and returns focus to its trigger.
  if (item.classList.contains('header__nav-item--mega-menu')) {
    item.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      item.classList.remove('is-open');
      item.classList.add('is-dismissed');
      setExpanded(false);
      trigger.focus();
    });
  }
});

// Header mega menu (sections/header.liquid): cascading columns. Hovering or
// focusing a link makes it the active item at its level, which shows its
// children in the next column and closes its siblings' columns.
document.querySelectorAll('[data-mega-menu]').forEach((menu) => {
  const trigger = menu.querySelector(':scope > .header__mega-menu-trigger');
  const root = menu.querySelector('[data-mega-menu-root]');
  if (!trigger || !root) return;

  // Brief delay before switching on hover, so moving diagonally from a link
  // to its open column doesn't activate the links passed over on the way.
  const HOVER_DELAY = 120;
  let hoverTimer;

  // Columns 2 and 3 are absolutely positioned, so grow the first column to
  // the tallest open one or they'd spill out of the panel.
  const fitHeight = () => {
    root.style.minHeight = '';
    let tallest = root.offsetHeight;
    root.querySelectorAll('.mega-menu__item.is-active > .mega-menu__list').forEach((list) => {
      tallest = Math.max(tallest, list.offsetHeight);
    });
    root.style.minHeight = `${tallest}px`;
  };

  const syncExpanded = () => {
    root.querySelectorAll('.mega-menu__item--has-children').forEach((item) => {
      item.querySelector(':scope > .mega-menu__link')?.setAttribute('aria-expanded', item.classList.contains('is-active'));
    });
  };

  const activate = (item) => {
    if (!item.classList.contains('is-active')) {
      item.parentElement.querySelectorAll(':scope > .mega-menu__item').forEach((sibling) => {
        if (sibling === item) return;
        sibling.classList.remove('is-active');
        sibling.querySelectorAll('.is-active').forEach((nested) => nested.classList.remove('is-active'));
      });
      item.classList.add('is-active');
      syncExpanded();
    }
    fitHeight();
  };

  root.querySelectorAll('.mega-menu__item').forEach((item) => {
    item.addEventListener('mouseenter', () => {
      clearTimeout(hoverTimer);
      hoverTimer = setTimeout(() => activate(item), HOVER_DELAY);
    });
  });

  root.addEventListener('focusin', (event) => {
    const item = event.target.closest('.mega-menu__item');
    if (!item) return;
    clearTimeout(hoverTimer);
    activate(item);
  });

  // The panel only has a size once it's showing, so measure on open.
  const onOpen = () => requestAnimationFrame(fitHeight);
  menu.addEventListener('mouseenter', onOpen);
  menu.addEventListener('focusin', onOpen);

  // Click/tap toggles the panel - touch screens have no hover, and it gives
  // mouse/keyboard users a way to close it without moving away. A mouse or
  // keyboard already has it showing (hover / focus), so toggle what's visible;
  // a tap toggles the tapped-open state, since emulated hover is unreliable.
  const panel = menu.querySelector(':scope > .mega-menu');
  let pointerType = '';
  trigger.addEventListener('pointerdown', (event) => {
    pointerType = event.pointerType;
  });

  trigger.addEventListener('click', () => {
    const isTouch = pointerType === 'touch' || pointerType === 'pen';
    pointerType = '';
    const showing = isTouch
      ? menu.classList.contains('is-open')
      : Boolean(panel) && getComputedStyle(panel).display !== 'none';
    const open = !showing;
    menu.classList.toggle('is-open', open);
    menu.classList.toggle('is-dismissed', !open);
    trigger.setAttribute('aria-expanded', open);
    if (open) onOpen();
  });

  menu.addEventListener('mouseleave', () => {
    clearTimeout(hoverTimer);
    menu.classList.remove('is-open');
  });

  document.addEventListener('click', (event) => {
    if (!menu.contains(event.target)) menu.classList.remove('is-open');
  });

  // Clicking the dimmed page (only clickable when tap/click-opened) closes it.
  const overlay = menu.querySelector(':scope > [data-mega-menu-overlay]');
  if (overlay) {
    overlay.addEventListener('click', () => {
      menu.classList.remove('is-open');
      menu.classList.add('is-dismissed');
      trigger.setAttribute('aria-expanded', 'false');
    });
  }
});

// Second-level flyouts inside a dropdown: keep aria-expanded in sync, and open
// the panel to the left instead when it would run off the right edge of the
// screen (e.g. the last top-level menu items).
document.querySelectorAll('.header__dropdown-item--has-children').forEach((item) => {
  const trigger = item.querySelector(':scope > .header__dropdown-link');
  const submenu = item.querySelector(':scope > .header__dropdown-submenu');
  if (!trigger || !submenu) return;

  const open = () => {
    trigger.setAttribute('aria-expanded', 'true');
    // Measure after it's displayed (hover/focus-within has already shown it).
    item.classList.remove('is-flipped');
    const rect = submenu.getBoundingClientRect();
    if (rect.width && rect.right > document.documentElement.clientWidth) {
      item.classList.add('is-flipped');
    }
  };

  const close = () => {
    trigger.setAttribute('aria-expanded', 'false');
  };

  item.addEventListener('mouseenter', open);
  item.addEventListener('mouseleave', close);
  item.addEventListener('focusin', open);
  item.addEventListener('focusout', (event) => {
    if (!item.contains(event.relatedTarget)) close();
  });
});

document.querySelectorAll('[data-mega-content][data-mode="image_per_link"]').forEach((content) => {
  const images = content.querySelectorAll('[data-hover-image]');
  if (images.length === 0) return;

  const showImage = (index) => {
    images.forEach((image, i) => {
      image.hidden = i !== index;
    });
  };

  showImage(0);

  const panel = content.closest('.header__mega-panel-inner');
  if (!panel) return;

  panel.querySelectorAll('[data-mega-link-index]').forEach((link) => {
    const index = parseInt(link.dataset.megaLinkIndex, 10);
    link.addEventListener('mouseenter', () => showImage(index));
    link.addEventListener('focus', () => showImage(index));
  });
});
